import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { BaseElement, customElement } from '../../../components';
import folderAccessIcon from '../../../assets/folder-access.svg?url';
import { handleGoHome, handleGoToMyAccount } from '../../../smart-components';
import '../../result/src/result.wc';

@customElement('ps-no-project-access')
export class NoProjectAccessWC extends BaseElement {
  @property({ attribute: 'project-name' }) projectName: string = '';

  render() {
    return html`
      <ps-result
        align="center"
        status="error"
        label=${`You don’t have access to the project ${this.projectName}`}
        body="Contact an admin or manage your access."
      >
        <ps-image
          slot="image"
          src=${folderAccessIcon}
          alt="Folder access icon"
          height="180"
        ></ps-image>
        <ps-stack gutter="xsmall" justifyContent="center" slot="footer">
          <ps-button
            size="xlarge"
            variant="secondary"
            @click=${() => handleGoToMyAccount()}
          >
            <ps-icon slot="prefix" name="avatar" size="xsmall"></ps-icon>
            My Account
          </ps-button>
          <ps-button
            size="xlarge"
            @click=${() => handleGoHome({ accountId: undefined })}
          >
            <ps-icon slot="prefix" name="home" size="xsmall"></ps-icon>
            Home
          </ps-button>
        </ps-stack>
      </ps-result>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-no-project-access': NoProjectAccessWC;
  }
}
